
import 'mapbox-gl/dist/mapbox-gl.css'
import mapboxgl from 'mapbox-gl/dist/mapbox-gl'
import Filters from '@/components/Filters'
import utils from '@/mixins/utils'
export default {
  mixins: [utils],
  name: 'Storelocator',
  components: {
    Filters,
  },
  data() {
    return {
      country: null,
      type: null,
      currentLocation: null,
      currentLocationOn: null,
      permissionDenied: null,
      selectedStoreID: null,
      map: null,
      mapboxAccessToken:
        'pk.eyJ1IjoiaGFua3lvdXN0dWRpbyIsImEiOiJjbHpta3NraTkwNXdtMmtyN2J3ZWFmcTU4In0.q6U2BLn4xk8jQJsKU35TxA',
      mapStyle: 'mapbox://styles/hankyoustudio/clzso6daw003m01r063lu64rj',
    }
  },
  computed: {
    filteredStores() {
      let stores = this.$store.state.stores
      if (this.country) {
        stores = stores.filter(
          (store) =>
            store.attributes.location.context[3].short_code === this.country
        )
      }

      if (this.type) {
        stores = stores.filter((store) => {
          return store.attributes.store_types.data.some(
            (type) => type.id === this.type
          )
        })
      }

      return stores
    },
    geoJson() {
      return {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: this.filteredStores.map(this.itemToGeoJSONPoint),
        },
      }
    },

    bounds() {
      return [
        [-122.66336, 37.492987],
        [-122.250481, 37.871651],
        [-30.250481, 37.871651],
      ]
    },

    countries() {
      const stores = this.$store.state.stores.map((store) => {
        return store.attributes.location.context[3]
      })
      // Return unique array of countries
      return Array.from([...new Set(stores).map(JSON.stringify)]).map(
        JSON.parse
      )
    },
    filters() {
      return [
        {
          name: 'type',
          field: 'store_types',
          data: this.createOptions(this.$store.state.storeTypes),
        },
        {
          name: 'country',
          field: 'country',
          data: this.createCountryOptions(this.countries),
        },
      ]
    },
  },

  watch: {
    $route(to, from) {
      this.checkQuery()
    },
    geoJson(newValue) {
      if (this.$refs.map.map && this.$refs.map.map.getSource('stores')) {
        this.$refs.map.map.getSource('stores').setData(newValue.data)
        setTimeout(function () {
          const bounds = new mapboxgl.LngLatBounds()

          self.geoJson.data.features.forEach(function (feature) {
            bounds.extend(feature.geometry.coordinates)
          })
          self.$refs.map.map.fitBounds(bounds, { maxZoom: 8 })
        }, 200)
      }
      const self = this
    },
  },

  methods: {
    checkQuery() {
      if (this.$route.query.type) {
        const result = this.$store.state.storeTypes.find((type) => {
          return this.slugify(type.attributes.title) === this.$route.query.type
        })
        if (result) {
          this.type = result.id
        } else {
          this.type = null
        }
      } else {
        this.type = null
      }
      if (this.$route.query.country) {
        const result = this.countries.find(
          (location) => location.short_code === this.$route.query.country
        )
        if (result) {
          this.country = result.short_code
        } else {
          this.country = null
        }
      } else {
        this.country = null
      }
    },
    createCountryOptions(arr) {
      const options = [
        {
          label: 'All',
          code: 'all',
          id: 'all',
        },
      ]
      arr.forEach((element) => {
        if (element.short_code) {
          options.push({
            label: element.text,
            code: this.slugify(element.short_code),
            id: element.id,
          })
        }
      })
      return options
    },
    formatAddress(location) {
      return (
        (location.properties.address ||
          location.text + ' ' + location.address) +
        ', ' +
        location.context[0].text +
        ' ' +
        location.context[1].text
      )
    },
    onMapLoaded(event) {
      const map = event.map
      map.loadImage(require('~/assets/images/marker.png'), (error, image) => {
        if (error) throw error
        // Add the image to the map style.
        map.addImage('custom-marker', image)
        map.addSource('stores', {
          type: 'geojson',
          data: this.geoJson.data,
          cluster: true,
          clusterMaxZoom: 14, // Max zoom to cluster points on
          clusterRadius: 50, // Radius of each cluster when clustering points (defaults to 50)
        })
        map.addLayer({
          id: 'clusters',
          type: 'circle',
          source: 'stores',
          filter: ['has', 'point_count'],
          paint: {
            'circle-color': [
              'step',
              ['get', 'point_count'],
              '#111111',
              100,
              '#111111',
              200,
              '#111111',
            ],
            'circle-radius': [
              'step',
              ['get', 'point_count'],
              20,
              100,
              30,
              750,
              40,
            ],
            'circle-stroke-color': '#111111',
            'circle-stroke-width': 5,
            'circle-stroke-opacity': 0.5,
          },
        })
        map.addLayer({
          id: 'cluster-count',
          type: 'symbol',
          source: 'stores',
          fadeDuration: 0,
          filter: ['has', 'point_count'],
          layout: {
            'text-field': ['get', 'point_count_abbreviated'],
            'text-font': ['DIN Offc Pro Medium', 'Arial Unicode MS Bold'],
            'text-size': 12,
          },
          paint: {
            'text-color': '#ffffff',
          },
        })
        map.addLayer({
          id: 'unclustered-point',
          type: 'symbol',
          source: 'stores',
          filter: ['!', ['has', 'point_count']],
          layout: {
            'icon-image': 'custom-marker',
            'icon-size': 0.08,
            'icon-anchor': 'bottom',
          },
        })
        // inspect a cluster on click
        map.on('click', 'clusters', (e) => {
          const features = map.queryRenderedFeatures(e.point, {
            layers: ['clusters'],
          })
          const clusterId = features[0].properties.cluster_id
          map
            .getSource('stores')
            .getClusterExpansionZoom(clusterId, (err, zoom) => {
              if (err) return
              map.easeTo({
                center: features[0].geometry.coordinates,
                zoom,
              })
            })
        })
        map.on('click', 'unclustered-point', (e) => {
          const store = e.features[0].properties
          store.attributes = JSON.parse(store.attributes)
          this.selectStore(store, true)
        })
        map.on('mouseenter', 'clusters', () => {
          map.getCanvas().style.cursor = 'pointer'
        })
        map.on('mouseleave', 'clusters', () => {
          map.getCanvas().style.cursor = ''
        })
        map.on('mouseenter', 'unclustered-point', () => {
          map.getCanvas().style.cursor = 'pointer'
        })
        map.on('mouseleave', 'unclustered-point', () => {
          map.getCanvas().style.cursor = ''
        })
      })
      this.checkQuery()
    },
    itemToGeoJSONPoint(item) {
      return {
        type: 'Feature',
        geometry: {
          type: 'Point',
          coordinates: [
            item.attributes.location.center[0],
            item.attributes.location.center[1],
          ],
        },
        properties: item,
      }
    },
    markerClick(store) {
      this.selectStore(store, true)
    },
    storeClick(store) {
      this.selectStore(store, false)
    },
    selectStore(store, scrollTo) {
      if (
        this.$refs['store-' + this.selectedStoreID] &&
        this.$refs['store-' + this.selectedStoreID][0]
      ) {
        this.$refs['store-' + this.selectedStoreID][0].classList.remove(
          'selected'
        )
      }
      this.flyTo(
        store.attributes.location.center[0],
        store.attributes.location.center[1],
        15
      )
      this.selectedStoreID = store.id
      if (
        this.$refs['store-' + store.id] &&
        this.$refs['store-' + store.id][0]
      ) {
        this.$refs['store-' + store.id][0].classList.add('selected')
        if (scrollTo) {
          this.$refs.listings.scrollTop =
            this.$refs['store-' + store.id][0].offsetTop
        }
      }
    },
    flyTo(lng, lat, zoom) {
      this.$refs.map.map.flyTo({
        center: [lng, lat],
        speed: 3,
        zoom,
      })
    },
    sortArray(arr) {
      arr.sort(function (a, b) {
        const textA = a.name.toUpperCase()
        const textB = b.name.toUpperCase()
        return textA < textB ? -1 : textA > textB ? 1 : 0
      })
      return arr
    },

    getLocation() {
      if (!this.currentLocation) {
        if (navigator.geolocation) {
          if (this.$nuxt && this.$nuxt.$loading) {
            this.$nuxt.$loading.start()
          }
          navigator.geolocation.getCurrentPosition(
            this.showPosition,
            this.positionError
          )
        } else {
          console.log('not supported!')
        }
      } else {
        this.currentLocationOn = null
        this.currentLocation = null
      }
    },
    positionError(error) {
      if (error.code === 1) {
        this.permissionDenied = true
      }
      if (this.$nuxt && this.$nuxt.$loading) {
        this.$nuxt.$loading.finish()
      }
    },
    showPosition(position) {
      this.currentLocation = position
      this.currentLocationOn = true
      this.permissionDenied = false
      if (this.$nuxt && this.$nuxt.$loading) {
        this.$nuxt.$loading.finish()
      }
      const self = this
      setTimeout(function () {
        self.flyTo(position.coords.longitude, position.coords.latitude, 12)
      }, 500)
    },

    getDistance(store) {
      if (store.location) {
        return this.distance(
          store.location.lat,
          store.location.lng,
          this.currentLocation.coords.latitude,
          this.currentLocation.coords.longitude,
          'K'
        )
      } else {
        return null
      }
    },
    getMaps(store) {
      return (
        'https://www.google.com/maps/dir/?api=1&destination=' +
        store.address +
        '&travelmode=driving'
      )
    },
    distance(lat1, lon1, lat2, lon2, unit) {
      if (lat1 === lat2 && lon1 === lon2) {
        return 0
      } else {
        const radlat1 = (Math.PI * lat1) / 180
        const radlat2 = (Math.PI * lat2) / 180
        const theta = lon1 - lon2
        const radtheta = (Math.PI * theta) / 180
        let dist =
          Math.sin(radlat1) * Math.sin(radlat2) +
          Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
        if (dist > 1) {
          dist = 1
        }
        dist = Math.acos(dist)
        dist = (dist * 180) / Math.PI
        dist = dist * 60 * 1.1515
        if (unit === 'K') {
          dist = dist * 1.609344
        }
        if (unit === 'N') {
          dist = dist * 0.8684
        }
        return dist.toFixed(1)
      }
    },
  },
}
